import useGetPerfis from "core/features/perfil/hooks/useGetPerfis";
import { useState } from "react";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
export interface SelectPerfilProps<T = any> extends SelectBaseAntdProps<T> {
  tenantId: string;
  filteredOptions?: string[];
}

function SelectPerfil({
  tenantId,
  filteredOptions,
  ...rest
}: SelectPerfilProps) {
  const [search, setSearch] = useState<string>();

  const { isLoading, data } = useGetPerfis(tenantId, {
    page: 1,
    limit: 1000,
  });

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      placeholder="Selecione um ou vários"
      mode="tags"
      searchValue={search}
      showSearch
      onSearch={setSearch}
      optionFilterProp="label"
      options={data?.items
        ?.filter((item) =>
          filteredOptions ? !filteredOptions.includes(item.id) : true
        )
        .map((item) => ({
          value: item.id,
          label: item.nome,
        }))}
      {...rest}
    />
  );
}

export default SelectPerfil;
